import { createSharedComposable } from '@vueuse/core'

const _useDashboard = () => {
  const route = useRoute()
  const router = useRouter()
  const isCommonNotificationsSlideoverOpen = ref(false)

  defineShortcuts({
    'g-h': () => router.push('/'),
    'g-i': () => router.push('/inbox'),
    'g-c': () => router.push('/customers'),
    'g-s': () => router.push('/settings'),
    'n': () => isCommonNotificationsSlideoverOpen.value = !isCommonNotificationsSlideoverOpen.value
  })

  watch(() => route.fullPath, () => {
    isCommonNotificationsSlideoverOpen.value = false
  })

  return {
    isCommonNotificationsSlideoverOpen
  }
}

export const useDashboard = createSharedComposable(_useDashboard)
